import React, { useEffect, useState } from 'react';

import { ReactComponent as IconCloseSvg } from '@/assets/icon-close.svg';
import RecoverPassword from '@/components/AuthModal/RecoverPassword';
import Register from '@/components/AuthModal/Register';
import Modal from '@/components/Modal';

import Login from './Login';
import * as S from './styles';

type CurrentBody = 'login' | 'register' | 'recover-password';

type Props = {
  open: boolean;
  onClose?: () => void;
  body?: CurrentBody;
};

const AuthModal = ({ open, onClose, body = 'login' }: Props) => {
  const [currentBody, setCurrentBody] = useState<CurrentBody>(body);

  useEffect(() => {
    setCurrentBody(body);
  }, [body]);

  return (
    <Modal open={open} onClose={onClose}>
      <S.Wrapper>
        <S.Links>
          <button
            type="button"
            className={currentBody === 'login' ? 'active' : ''}
            onClick={() => setCurrentBody('login')}
          >
            Login
          </button>

          <button
            type="button"
            className={currentBody === 'register' ? 'active' : ''}
            onClick={() => setCurrentBody('register')}
          >
            Registro
          </button>
        </S.Links>

        <S.CloseButton onClick={onClose}>
          <IconCloseSvg />
        </S.CloseButton>

        <S.Content>
          {currentBody === 'login' && (
            <Login
              onSuccess={onClose}
              onClickRecoverPassword={() => setCurrentBody('recover-password')}
            />
          )}

          {currentBody === 'register' && <Register onSuccess={onClose} />}
          {currentBody === 'recover-password' && (
            <RecoverPassword onSuccess={onClose} />
          )}
        </S.Content>
      </S.Wrapper>
    </Modal>
  );
};

export default AuthModal;
